/**
 * Silence diagnostic console output in production builds.
 *
 * error/warn are deliberately left intact: Sentry attaches breadcrumbs to them
 * and suppressing them hides real failures from both users and monitoring.
 */

const SUPPRESSED_METHODS = [
  'log',
  'info',
  'debug',
  'trace',
  'table',
  'time',
  'timeEnd',
  'group',
  'groupEnd',
  'groupCollapsed',
];

export const disableConsoleInProduction = () => {
  if (process.env.NODE_ENV !== 'production') return;

  const noop = () => {};
  window._originalConsole = SUPPRESSED_METHODS.reduce((acc, method) => {
    acc[method] = console[method];
    console[method] = noop;
    return acc;
  }, {});
};

export const restoreConsole = () => {
  if (!window._originalConsole) return;
  Object.keys(window._originalConsole).forEach((method) => {
    console[method] = window._originalConsole[method];
  });
};
